"use client";

import { ReCaptchaProvider as NextReCaptchaProvider } from "next-recaptcha-v3";

export default function ReCaptchaProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <NextReCaptchaProvider
      reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || ""}
    >
      {children}
    </NextReCaptchaProvider>
  );
}
